import StateFilteredAddress from '../forms/address/StateFilteredAddress';
import { StateFilterData } from '../forms/address/types';
import FormHandler from '../forms/FormHandler';
import LevelFirstFormPostHandler from './LevelFirstFormPostHandler';
import type { AddMembershipResponse } from './LevelFirstFormService';

class LevelFirstForm {
  constructor($form: HTMLFormElement, stateFilterData: StateFilterData) {
    const formHandler = new FormHandler($form, {
      postHandler: LevelFirstFormPostHandler,
      onValidationSuccess: ({ data, stopSubmitting }) => {
        const response = data as AddMembershipResponse;

        if (response.isSuccessful) {
          window.location.href = response.redirectUrl!;
          return;
        }

        if (response.errorMessage) {
          formHandler.addErrorMessage(response.errorMessage, true);
        }

        stopSubmitting();
      },
    });

    StateFilteredAddress.createForCustomFormFields($form, formHandler, stateFilterData);
  }
}

export default LevelFirstForm;
